import * as React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Link, RestrictedAccessTooltip } from "components/common";
import { defaultCompare } from "logic/DefaultCompare";
import useShowRouteFromGRN from "routing/hooks/useShowRouteFromGRN";
import usePermissions from "hooks/usePermissions";
import { getValuesFromGRN } from "logic/permissions/GRN";
const OwnerList = styled.div`
  display: flex;
`;
const OwnerTitleWrapper = styled.span`
  display: flex;
  align-items: center;
`;
const TitleWithLink = ({ title, entityGrn }) => {
  const entityRoute = useShowRouteFromGRN(entityGrn);
  return /* @__PURE__ */ React.createElement(Link, { to: entityRoute }, title);
};
const assertUnreachable = (type) => {
  throw new Error(`Owner of entity has not supported type: ${type}`);
};
const OwnerTitle = ({ owner: { type, id: grn, title } }) => {
  const { t } = useTranslation("users");
  const { isPermitted } = usePermissions();
  const { id: ownerId } = getValuesFromGRN(grn);
  switch (type) {
    case "user":
      if (!isPermitted(`users:edit:${ownerId}`))
        return /* @__PURE__ */ React.createElement(OwnerTitleWrapper, null, title, " ", /* @__PURE__ */ React.createElement(RestrictedAccessTooltip, { entityName: type, capabilityName: "view" }));
      return /* @__PURE__ */ React.createElement(TitleWithLink, { title, entityGrn: grn });
    case "team":
      if (!isPermitted(`team:edit:${ownerId}`))
        return /* @__PURE__ */ React.createElement(OwnerTitleWrapper, null, title, " ", /* @__PURE__ */ React.createElement(RestrictedAccessTooltip, { entityName: type, capabilityName: "view" }));
      return /* @__PURE__ */ React.createElement(TitleWithLink, { title, entityGrn: grn });
    case "global":
      return /* @__PURE__ */ React.createElement("span", null, t("permissions.grantee_types.global"));
    default:
      return assertUnreachable(type);
  }
};
const OwnersCell = ({ owners }) => {
  const sortedOwners = owners.sort((o1, o2) => defaultCompare(o1.type, o2.type) || defaultCompare(o1.title, o2.title));
  return /* @__PURE__ */ React.createElement("td", { className: "limited" }, /* @__PURE__ */ React.createElement(OwnerList, null, sortedOwners.map((owner, index) => {
    const isLast = index >= owners.size - 1;
    return /* @__PURE__ */ React.createElement(React.Fragment, { key: owner.id }, /* @__PURE__ */ React.createElement(OwnerTitle, { owner }), !isLast && /* @__PURE__ */ React.createElement(React.Fragment, null, ", \xA0"));
  }).toArray()));
};
export default OwnersCell;
